import { Module, VuexModule, Mutation, Action, getModule } from 'vuex-module-decorators';
import {トークン型, 代行ログイントークン型, 認証型} from '@/type/authentication/authentication';
import api from '@/infrastructure/api/api';
import store from '@/store';

@Module({ dynamic: true, store, name: 'token', namespaced: true })
class Token extends VuexModule {
    public トークン: トークン型 = {
        アクセストークン: '',
        リフレッシュトークン: '',
    };

  @Mutation
  public authenticate(トークン: トークン型) {
    this.トークン = トークン;
  }

  @Mutation
  public accessToken(アクセストークン: string) {
    this.トークン.アクセストークン = アクセストークン;
  }

  @Mutation
  public clearToken() {
    this.トークン = {
      アクセストークン: '',
      リフレッシュトークン: '',
    };
  }

  @Mutation
  public clearAccessToken() {
    this.トークン.アクセストークン = '';
  }

  @Action({ rawError: true })
  public async 認証する(認証: 認証型): Promise<void> {
    const トークン = await api.authenticate(認証);
    this.authenticate(トークン);
  }

    @Action({ rawError: true })
    public async マスターアカウントの認証をする(代行ログイントークン: 代行ログイントークン型): Promise<void> {
        const トークン = await api.authenticateMasterAccount(代行ログイントークン);
        this.authenticate(トークン);
    }

  @Action({ rawError: true })
  public async 再取得する(): Promise<void> {
    await api.refresh(this.リフレッシュトークンを取得する)
      .then((response: any) => {
        this.accessToken(response);
      })
      .catch((response: any) => {
        this.clearToken();
      });
  }

  @Action
  public 削除する(): void {
    this.clearToken();
  }

  @Action
  public トークンを戻す(トークン: トークン型): void {
    this.authenticate(トークン);
  }

  public get 認証されている(): boolean {
    if (this.トークン.リフレッシュトークン) {
      return true;
    }
    return false;
  }

  public get リフレッシュトークンを取得する() {
    return this.トークン.リフレッシュトークン;
}

  public get アクセストークンを取得する() {
      return this.トークン.アクセストークン;
  }
}

export const tokenModule = getModule(Token);
